// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

p {
  font-size: 16px;
  font-weight: 600;
}

input[type=range] {
  -webkit-appearance: none;
  display: block;
  border-radius: 25px;
  border: 0.5px solid gray;
  margin: 0;
  width: 100%;
  background: transparent;
}

input[type=range]::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  color: transparent;
  background: #fff;
  border-radius: 999px;
  border: none;
  cursor: pointer;
}

input[type=range]::-moz-range-track {
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  color: transparent;
  background: #fff;
  border-radius: 999px;
  border: none;
  cursor: pointer;
}

input[type=range]::-ms-track {
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  color: transparent;
  background: #fff;
  border-radius: 999px;
  border: none;
  cursor: pointer;
}

input[type=range]::-ms-fill-lower {
  display: none;
}

input[type=range]::-ms-fill-upper {
  display: none;
}

input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 35px;
  width: 35px;
  margin-top: -13px;
  border-radius: 30px;
  background: #4383c2;
  box-shadow: 0px 2px 10px -2px #4383C2 1;
}

input[type=range]::-moz-range-thumb {
  -webkit-appearance: none;
  height: 35px;
  width: 35px;
  margin-top: -13px;
  border-radius: 30px;
  background: #4383c2;
  box-shadow: 0px 2px 10px -2px #4383C2 1;
}

input[type=range]::-ms-thumb {
  -webkit-appearance: none;
  height: 35px;
  width: 35px;
  margin-top: -13px;
  border-radius: 30px;
  background: #4383c2;
  box-shadow: 0px 2px 10px -2px #4383C2 1;
}

.ticks {
  display: flex;
  justify-content: space-between;
  padding: 5px 16.5px;
}

.tick {
  position: relative;
  display: flex;
  justify-content: center;
  width: 1px;
  margin-top: 10px;
  background: gray;
  font-weight: 600;
  font-size: 14px;
  height: 10px;
  line-height: 50px;
  margin-bottom: 20px;
}

@media (min-width: 775px) and (max-width: 995px) {
  .tick {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/slider-select/slider-select.component.scss"],"names":[],"mappings":"AAIA;EACE,sBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;AAHF;;AA2BA;EACE,wBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;AAxBF;;AA0BA;EA3BE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;AAKF;;AAkBA;EA9BE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;AAgBF;;AAUA;EAjCE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;AA2BF;;AAEA;EACE,aAAA;AACF;;AACA;EACE,aAAA;AAEF;;AAAA;EAhCE,wBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uCAAA;AAoCF;;AAPA;EAnCE,wBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uCAAA;AA8CF;;AAdA;EAtCE,wBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uCAAA;AAwDF;;AAnBA;EACE,aAAA;EACA,8BAAA;EAGA,mBAAA;AAoBF;;AAlBA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EAEA,YAAA;EACA,iBAAA;EACA,mBAAA;AAoBF;;AAjBA;EACI;IACE,eAAA;EAoBJ;AACF","sourcesContent":["//Tick width & range thumb width need to be in sync, that's why I'm using the $unit variable.\n$unit: 5px;\n\n//Some basic setup first\n* {\n  box-sizing: border-box;\n}\n\np {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n//Some range styling.\n//Using mixins because each major browser needs a separate selector to style parts of the range input, combining selectors would invalidate the whole selector on each browser\n@mixin range-track {\n  -webkit-appearance: none;\n  width: 100%;\n  height: $unit * 2;\n  color: transparent;\n  background: #fff;\n  border-radius: 999px;\n  border: none;\n  cursor: pointer;\n}\n@mixin range-thumb {\n  -webkit-appearance: none;\n  height: $unit * 7;\n  width: $unit * 7;\n  margin-top: -13px;\n  border-radius: 30px;\n  background: #4383c2;\n  box-shadow: 0px 2px 10px -2px #4383C2(1);\n}\ninput[type='range'] {\n  -webkit-appearance: none;\n  display: block;\n  border-radius: 25px;\n  border: 0.5px solid gray;\n  margin: 0;\n  width: 100%;\n  background: transparent;\n}\ninput[type='range']::-webkit-slider-runnable-track {\n  @include range-track();\n}\ninput[type='range']::-moz-range-track {\n  @include range-track();\n}\ninput[type='range']::-ms-track {\n  @include range-track();\n}\ninput[type='range']::-ms-fill-lower {\n  display: none;\n}\ninput[type='range']::-ms-fill-upper {\n  display: none;\n}\ninput[type='range']::-webkit-slider-thumb {\n  @include range-thumb();\n}\ninput[type='range']::-moz-range-thumb {\n  @include range-thumb();\n}\ninput[type='range']::-ms-thumb {\n  @include range-thumb();\n}\n\n//And now the ticks\n.ticks {\n  display: flex;\n  justify-content: space-between;\n\n  //We need left & right padding that's half the width of the range thumb, so all ticks align with the center of the thumb\n  padding: $unit $unit * 3.3;\n}\n.tick {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: 1px;\n  margin-top: 10px;\n  background: gray;\n  font-weight: 600;\n  font-size: 14px;\n  //Cap the height of the tick & push text down, so the tick renders as a little line and the text doesn't overlap the line. Also add margin, so the container expands enough that the next element you'll add won't overlap the ticks.\n  height: $unit * 2;\n  line-height: $unit * 10;\n  margin-bottom: $unit * 4;\n}\n\n@media (min-width: 775px) and (max-width: 995px) {\n    .tick {\n      font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
